<script>
export default {
  name: 'CardTickIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 15C16.79 15 15 16.79 15 19C15 19.75 15.21 20.46 15.58 21.06C16.27 22.22 17.54 23 19 23C20.46 23 21.73 22.22 22.42 21.06C22.79 20.46 23 19.75 23 19C23 16.79 21.21 15 19 15ZM21.07 18.57L18.94 20.54C18.8 20.67 18.61 20.74 18.43 20.74C18.24 20.74 18.05 20.67 17.9 20.52L16.91 19.53C16.62 19.24 16.62 18.76 16.91 18.47C17.2 18.18 17.68 18.18 17.97 18.47L18.45 18.95L20.05 17.47C20.35 17.19 20.83 17.21 21.11 17.51C21.39 17.81 21.37 18.28 21.07 18.57Z"
      :fill="color"
    />
    <path
      d="M22 7.55039V8.00039C22 8.55039 21.55 9.00039 21 9.00039H3C2.45 9.00039 2 8.55039 2 8.00039V7.54039C2 5.25039 3.85 3.40039 6.14 3.40039H17.85C20.14 3.40039 22 5.26039 22 7.55039Z"
      :fill="color"
    />
    <path
      d="M2 11.5002V16.4602C2 18.7502 3.85 20.6002 6.14 20.6002H12.4C12.98 20.6002 13.48 20.1102 13.43 19.5302C13.29 18.0002 13.78 16.3402 15.14 15.0202C15.7 14.4702 16.39 14.0502 17.14 13.8102C18.39 13.4102 19.6 13.4602 20.67 13.8202C21.32 14.0402 22 13.5702 22 12.8802V11.4902C22 10.9402 21.55 10.4902 21 10.4902H3C2.45 10.5002 2 10.9502 2 11.5002ZM8 17.2502H6C5.59 17.2502 5.25 16.9102 5.25 16.5002C5.25 16.0902 5.59 15.7502 6 15.7502H8C8.41 15.7502 8.75 16.0902 8.75 16.5002C8.75 16.9102 8.41 17.2502 8 17.2502Z"
      :fill="color"
    />
  </svg>
</template>
